export const clientReportsAccionesRoles = {
  sideNavActions: {
    clientReportsRotomolding: ['ClientPBIRotomolding', 'Admin'],
  },
};
